import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { Link, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';

import {
  isArchive,
  resizeSplitContentContainer,
} from '../helpers/App';

const ArchiveSearchHeader = ({ filesArchived }) => {
  const intl = useIntl();
  const location = useLocation();
  const [searchParamsString, setSearchParamsString] = useState('');

  useEffect(() => {
    resizeSplitContentContainer();
  }, [filesArchived]);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    setSearchParamsString(searchParams.toString());
  }, [location]);

  if (isArchive() || filesArchived === 0) {
    return null;
  }

  return (
    <div className="archive-header">
      {intl.formatMessage({
        defaultMessage: 'There are more {filesArchived, plural, one {file} other {files}} in the archive',
      }, { filesArchived })}
      <Button
        size="sm"
        tag={Link}
        to={`/archive/files?${searchParamsString}`}
      >
        {intl.formatMessage({
          defaultMessage: 'Browse archive',
        })}
      </Button>
    </div>
  );
};

const mapStateToProps = state => ({
  filesArchived: state.Files.filesArchived,
});

ArchiveSearchHeader.propTypes = {
  filesArchived: PropTypes.number.isRequired,
};

export default connect(mapStateToProps)(ArchiveSearchHeader);
